module.exports = __webpack_public_path__ + "img/turtle.d5f3e593.svg";